/**
 * Forgot password module.
 *
 * There are 3 stages:
 * 1. enter email
 * 2. user enter verification token from their email inbox.
 * 3. token is validated, user can reset password now.
 *
 * After success, we will redirect user to login page.
 */
import React, { Component } from 'react';
import i18n from '../../config/i18n';
import { ForgotPasswordAPIConnectors } from '../../api/index';
import EmailForm from '../../components/login/EmailForm';
import ValidationForm from '../../components/login/ValidationForm';
import ResetForm from '../../components/login/ResetForm';
import connectActionAndReducer from '../../toolbox/connectActionsAndReducers';

const hintTexts = {
  0: i18n.t('getResetPwdByEmailMsg'),
  1: i18n.t('enterTokenMsg'),
  2: i18n.t('pwdRuleMsg'),
};

class ForgotPasswordContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentStage: 0,
      userId: '',
      userEmail: '',
      accessToken: '',
    };

    this.generateResetToken = this.generateResetToken.bind(this);
    this.verifyResetToken = this.verifyResetToken.bind(this);
    this.updatePassword = this.updatePassword.bind(this);
  }

  generateResetToken(email) {
    const { actions } = this.props;
    this.setState({ userEmail: email }); // save the email for the stage 2
    return ForgotPasswordAPIConnectors.generateResetToken(email)
      .then(() => {
        actions.createSuccessAlert(i18n.t('checkEmailMsg'));
        this.setState({ currentStage: 1 });
      })
      .catch((err) => {
        actions.createDangerAlert(err.message);
      });
  }

  verifyResetToken(token) {
    const { actions } = this.props;
    const { userEmail } = this.state;

    return ForgotPasswordAPIConnectors.verifyResetToken(userEmail, token)
      .then((data) => {
        this.setState({
          userId: data.userId,
          accessToken: data.id,
          currentStage: 2,
        });
        actions.createSuccessAlert(i18n.t('tokenVerifiedMsg'));
      })
      .catch((err) => {
        actions.createDangerAlert(err.message);
      });
  }

  updatePassword(newPassword) {
    const { actions } = this.props;
    const {
      userId,
      accessToken,
    } = this.state;

    return ForgotPasswordAPIConnectors.updatePassword(userId, newPassword, accessToken)
      .then(() => {
        actions.createSuccessAlert(i18n.t('resetPwdSucceedMsg'));
        setTimeout(() => {
          window.location = '/login';
        }, 2000);
      })
      .catch((err) => {
        actions.createDangerAlert(err.message);
      });
  }

  render() {
    let currentView = null;

    switch (this.state.currentStage) {
      default:
      case 0: {
        currentView = (<EmailForm generateResetToken={this.generateResetToken} />);
        break;
      }
      case 1: {
        currentView = (<ValidationForm verifyResetToken={this.verifyResetToken} />);
        break;
      }
      case 2: {
        currentView = (<ResetForm updatePassword={this.updatePassword} />);
        break;
      }
    }
    return (
      <div>
        <h1>
          {i18n.t('forgotPwd')}
        </h1>
        <p className="lead">{hintTexts[this.state.currentStage]}</p>
        {currentView}
        <p>
          {i18n.t('backTo')} <a href="/login">{i18n.t('login')}</a>
        </p>
      </div>
    );
  }
}

export default connectActionAndReducer(ForgotPasswordContainer);



// WEBPACK FOOTER //
// ./src/containers/login/ForgotPasswordContainer.js